/**
 * Pulls the human-readable message out of a backend response body, supporting the
 * common shapes this API returns: a bare string, `{ message }`, `{ data: "..." }`,
 * or `{ data: { message } }`.
 */
export function extractApiMessage(body: unknown): string | undefined {
  if (typeof body === "string") {
    const trimmed = body.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (body != null && typeof body === "object") {
    const record = body as Record<string, unknown>;

    if (typeof record.message === "string" && record.message.trim()) {
      return record.message.trim();
    }

    const data = record.data;
    if (typeof data === "string" && data.trim()) {
      return data.trim();
    }
    if (data != null && typeof data === "object") {
      const nested = data as Record<string, unknown>;
      if (typeof nested.message === "string" && nested.message.trim()) {
        return nested.message.trim();
      }
    }
  }
  return undefined;
}
